import { Pass, Dep, Seq } from "../../framework/Processes";
import { External } from "../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../framework/comp/Types";
import AtomicMinigameProcess from "./AtomicMinigameProcess";
import CompositeMinigameProcess from "./CompositeMinigameProcess";
import getNextMinigame from "../getNextMinigame";
import nextRound from "../minigames/restartTasks/countSelect";
import finishRound from "./finalMinigame";
import endGame from "../minigames/endGame/endGame";


export function RunAtomicTask(task) {
	return RunMinigameProcess({ minigames: [task], initMinigames: [1,2,3,4,5], constraints:[], service: [finishRound, nextRound, endGame], type: "menu" })
}

export function RunAtomicTasks(config, nextProccess = Pass) {
	return RunMinigameProcess(config, nextProccess);
}

/**
 * Convert a minigame config to a process.
 * @param {MinigamesConfig} config - minigame config
 * @param {Process} [nextProcess] - continuation (next process to run)
 * @return {Process} a process attached to a subject "Player"
 */
function RunMinigameProcess(config, nextProcess = Pass) {
	// if config is a sequence of minigames
	if (config.sequence) {
		const minigameProcesses = config.sequence.map(RunAtomicTask);
		return Seq([...minigameProcesses, nextProcess]);
	}
	// if config is a set of tasks with constraints
	return Dep(External(function (state) {
		const shouldFinish = (state.objects.history.length >= state.objects.count + 4);
		const minigame = getNextMinigame(config, state);
		if (minigame === undefined) {
			return nextProcess;
		};
		// if minigame is composite
		if (minigame.components) return CompositeMinigameProcess(minigame, RunMinigameProcess(config, nextProcess));
		// if minigame is atomic
		return AtomicMinigameProcess(minigame, RunMinigameProcess(config, shouldFinish ? undefined : nextProcess), config);
	}, "Function", FunctionType("Object", "Process")));
}

export default RunMinigameProcess;